module.exports = __webpack_public_path__ + "static/media/nuevoconocimiento.1050cecf.png";